import axios from "../api.js";
// **首页 11
export const home = () =>
	axios(
		"/api/home",
		{
			p: "w",
		},
		"GET"
	);

// **查询是否开启缅怀模式  11
export const getRemembranceMode = () =>
	axios(
		"/api/one_key_ash_setting",
		{
			p: "w",
		},
		"GET"
	);
// **参观指南  11
export const getVisitInfo = () =>
	axios(
		"/api/visit_guide",
		{
			p: "w",
		},
		"GET"
	);
// **网上预约  240729改成下载中心
export const getTicketInfo = () =>
	axios(
		"/api/online_booking",
		{
			p: "w",
		},
		"GET"
	);

// ** 首页- 馆藏精品 11
export const getExhibitList = (skip, take) =>
	axios(
		"/api/exhibit_list",
		{
			p: "w",
			cate_id: 1,
			skip: skip,
			take: take,
		},
		"GET"
	);

// **通知公告列表 11
export const getList = (skip, take) =>
	axios(
		"/api/news_list",
		{
			p: "w",
			skip: skip,
			take: take,
		},
		"GET"
	);

// **动态详情 11
export const getArtcileDetail = (id) =>
	axios(
		"/api/notice_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);

// ** 资讯动态列表 ** 11
export const getNewList = (skip, take) =>
	axios(
		"/api/notice_list",
		{
			p: "w",
			skip: skip,
			take: take,
		},
		"GET"
	);

// **资讯动态详情** 11
export const getNewDetail = (id) =>
	axios(
		"/api/news_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);

// **展览列表** 【基本陈列】
export const getBaseList = (skip, take) =>
	axios(
		"/api/base_exhibition_list",
		{
			p: "w",
			skip: 0,
			take: 100,
		},
		"GET"
	);
// **展览列表** 【专题展览】
export const getSpecialList = (skip, take) =>
	axios(
		"/api/special_exhibition_list",
		{
			p: "w",
			skip: 0,
			take: 100,
		},
		"GET"
	);
// **展览列表** 【展览回顾】
export const getReviewList = (skip, take) =>
	axios(
		"/api/review_exhibition_list",
		{
			p: "w",
			skip: 0,
			take: 100,
		},
		"GET"
	);

// **展厅详情** 【基本陈列】
export const getBaseDetail = (id) =>
	axios(
		"/api/base_exhibition_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);
// **展厅详情** 【专题展览】
export const getSpecialDetail = (id) =>
	axios(
		"/api/special_exhibition_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);
// **展厅详情** 【展览回顾】
export const getReviewDetail = (id) =>
	axios(
		"/api/review_exhibition_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);

// **展品详情** 11
export const getExhibitDetail = (id) =>
	axios(
		"/api/exhibit_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);

// **展览列表** 【线上展览】
export const getOnlineList = (skip, take) =>
	axios(
		"/api/exhibition_list_online",
		{
			p: "w",
			skip: 0,
			take: 100,
		},
		"GET"
	);

// **线上展览详情** 11
export const getOnlineExhibitionDetail = (id) =>
	axios(
		"/api/online_exhibition_info",
		{
			p: "w",
			id: id,
		},
		"GET"
	);



// WEBPACK FOOTER //
// ./src/http/module/interface.js